module.exports = __webpack_public_path__ + "img/entrance_plant_2.da983d95.jpg";